/** @format */

export enum LineItemState {
    UNDEFINED_STATE = 'UNDEFINED_STATE',
    ALLOCATED = 'ALLOCATED',
    PROPOSED = 'PROPOSED',
    CONFIRMED = 'CONFIRMED',
    DECLINED = 'DECLINED',
    FAILED = 'FAILED',
    CANCELLED = 'CANCELLED',
    RETURNING = 'RETURNING',
    RETURNED = 'RETURNED',
    NOT_RECEIVED = 'NOT_RECEIVED',
}
